import { Count } from 'Src/models/count';
import { superAdminGet } from './api';

export interface SuperAdminUserActivityFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

export interface SuperAdminUserActivity {
  id: string;
  _id?: string;
  userId?: string;
  userEmail?: string;
  httpVerb?: string;
  httpUrl?: string;
  httpStatusCode?: number;
  httpHeaders?: {
    'x-real-ip'?: string;
    [key: string]: string | undefined;
  };
  startedAt?: string;
  finishedAt?: string;
  user?: {
    id?: string;
    _id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    avatar?: string;
  };
}

export function getSuperAdminUserActivities(
  filter: SuperAdminUserActivityFilter = {}
): Promise<SuperAdminUserActivity[]> {
  return superAdminGet('/useractivity', { params: { filter } });
}

export function getSuperAdminUserActivitiesCount(where: any = {}): Promise<Count> {
  return superAdminGet('/useractivity/count', { params: { filter: { where } } });
}

export function getSuperAdminUserActivity(activityId: string): Promise<SuperAdminUserActivity> {
  return superAdminGet(`/useractivity/${activityId}`);
}
